import React, { CSSProperties, FunctionComponent } from 'react';
import styled from '@emotion/styled';

import { colours } from '../style/variables';
import wordmark from '../assets/logo.webp';

type LogoKind = 'wordmark' | 'full';

export interface LogoProps {
  kind: LogoKind;
  /**
   * Height (in pixels) of logo. Inferred from width if excluded
   */
  height?: number;
  /**
   * Width (in pixels) of logo. Inferred from height if excluded
   */
  width?: number;
  title?: string;
  fill?: string;
  style?: CSSProperties;
  className?: string;
}

const WORDMARK_RATIO = 2048 / 779;
const DEFAULT_HEIGHT = 32;

const LogoMark = styled.span`
  display: inline-block;
  flex: 0 0 auto;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: 100% 100%;
`;

export const Logo: FunctionComponent<LogoProps> = ({
  height,
  width,
  title = 'Helfy',
  fill = colours.primary,
  style,
  className,
}) => {
  const resolvedHeight = height ?? (width ? width / WORDMARK_RATIO : DEFAULT_HEIGHT);
  const resolvedWidth = width ?? resolvedHeight * WORDMARK_RATIO;

  return (
    <LogoMark
      role="img"
      aria-label={title}
      title={title}
      className={className}
      style={{
        backgroundColor: fill,
        height: `${resolvedHeight}px`,
        width: `${resolvedWidth}px`,
        WebkitMaskImage: `url(${wordmark})`,
        maskImage: `url(${wordmark})`,
        ...style,
      }}
    />
  );
};
